'use client';
import React, { useEffect, useState } from 'react';
import AppLogo from '@/components/ui/AppLogo';
import { useRouter } from 'next/navigation';

export default function Header() {
  const router = useRouter();
  const [scrolled, setScrolled] = useState(false);

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 60);
    window.addEventListener('scroll', onScroll, { passive: true });
    return () => window.removeEventListener('scroll', onScroll);
  }, []);

  return (
    <header
      className="fixed top-0 inset-x-0 z-50 transition-all duration-500"
      style={{
        background: scrolled
          ? 'rgba(13,13,13,0.92)'
          : 'transparent',
        backdropFilter: scrolled ? 'blur(16px)' : 'none',
        borderBottom: scrolled ? '1px solid rgba(63,63,70,0.6)' : 'none',
      }}
    >
      <div className="max-w-7xl mx-auto px-6 py-4 flex items-center justify-between">
        <AppLogo
          src="/assets/images/Social_Media_Blue-1777337599740.png"
          size={40}
          text="ATL Detailing & Services Inc."
          onClick={() => router.push('/home')}
        />
        <nav className="hidden md:flex items-center gap-1">
          {(['Services', 'Comparison', 'Book Now'] as const).map((item) => {
            const href = item === 'Book Now' ? '#book' : item === 'Comparison' ? '#compare' : '#services';
            const isBook = item === 'Book Now';
            return isBook ? (
              <a
                key={item}
                href={href}
                className="btn-primary text-sm px-5 py-2.5 ml-2"
                style={{ fontSize: '14px', padding: '10px 22px' }}
              >
                Book Now
              </a>
            ) : (
              <a
                key={item}
                href={href}
                className="px-4 py-2 rounded-full text-sm font-medium transition-colors duration-200"
                style={{ color: 'var(--aluminum-dim)', fontFamily: 'Manrope, sans-serif' }}
                onMouseEnter={(e) => (e.currentTarget.style.color = 'var(--white)')}
                onMouseLeave={(e) => (e.currentTarget.style.color = 'var(--aluminum-dim)')}
              >
                {item}
              </a>
            );
          })}
        </nav>
        {/* Mobile */}
        <a href="#book" className="md:hidden btn-primary" style={{ fontSize: '13px', padding: '9px 18px' }}>
          Book
        </a>
      </div>
    </header>
  );
}